import { render, staticRenderFns } from "./flex-col.vue?vue&type=template&id=cbbfc452&scoped=true"
import script from "./flex-col.vue?vue&type=script&lang=js"
export * from "./flex-col.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbfc452",
  null
  
)

export default component.exports